export const projectsData = [
  {
    projectName: "Expense",
    projectValue: 1000,
    projectDuration: 3
  },
  {
    projectName: "Transport",
    projectValue: 500,
    projectDuration: 5
  },
  {
    projectName: "Goodies",
    projectValue: 10000,
    projectDuration: 8
  }
];
